import { authRequest } from './client';
import {
  type ListWebhookDeliveriesParams,
  type ListWebhookDeliveriesResponse,
  type WebhookDeliveryDetailResponse,
} from './types';

// ─── backoffice-api webhook-deliveries client ──────────────────────────────
//
// Thin fetch wrappers around the GLOBAL `GET /v1/webhook-deliveries`
// endpoints (Task 30 — cross-merchant, read-only). Distinct from the
// merchant-scoped `getMerchantWebhookDeliveries` in `api/merchants.ts` (Task
// 25) — a different backend route with a different filter set; do not
// confuse or merge them. Both require TECH_VIEWER (or SUPERADMIN).

export function listWebhookDeliveries(
  params: ListWebhookDeliveriesParams = {},
): Promise<ListWebhookDeliveriesResponse> {
  const query = new URLSearchParams();

  if (params.page !== undefined) query.set('page', String(params.page));
  if (params.pageSize !== undefined) query.set('pageSize', String(params.pageSize));
  if (params.status !== undefined) query.set('status', params.status);
  if (params.eventType !== undefined) query.set('eventType', params.eventType);
  if (params.merchantId !== undefined) query.set('merchantId', params.merchantId);
  if (params.from !== undefined) query.set('from', params.from);
  if (params.to !== undefined) query.set('to', params.to);

  const qs = query.toString();
  return authRequest<ListWebhookDeliveriesResponse>(`/webhook-deliveries${qs ? `?${qs}` : ''}`);
}

export function getWebhookDelivery(id: string): Promise<WebhookDeliveryDetailResponse> {
  return authRequest<WebhookDeliveryDetailResponse>(`/webhook-deliveries/${id}`);
}
